import styled from 'styled-components';
import { gridAreas } from './config';
import { Direction } from './types';

export const StyledAutoFlowGrid = styled.div<{ $direction: Direction }>`
	width: 100%;
	display: grid;
	grid-auto-flow: dense;
	grid-gap: 8px;
	grid-template-columns: ${(props) => gridAreas[props.$direction].gridTemplateColumns};
	grid-template-areas: ${(props) => gridAreas[props.$direction].areas};

	@media (max-width: 768px) {
		grid-template-areas: ${(props) => gridAreas[props.$direction].areasMobile};
		grid-template-columns: ${(props) => gridAreas[props.$direction].gridTemplateColumnsMobile};
	}

	& * {
		object-fit: cover;
		width: 100%;
		height: auto;
	}

	@media (min-width: 768px) {
		& :nth-child(1) {
			height: ${(props) =>
				props.$direction === 'bigImageFirst'
					? '100%'
					: 'auto'}; // safari does not handle 100% height well for images in grids, but the big images need it otherwise they have some white space in the bottom
		}

		& :nth-child(3) {
			transform: ${(props) => (props.$direction === 'bigImageFirst' ? 'scale(-1, 1)' : 'none')};
			height: ${(props) =>
				props.$direction === 'smallImagesFirst'
					? '100%'
					: 'auto'}; // safari does not handle 100% height well for images in grids, but the big images need it otherwise they have some white space in the bottom
		}
	}

	img[src='//about:blank']
	{
		opacity: 0;
	}
`;
